import {
  Box,
  Button,
  createStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import {Pagination} from "@material-ui/lab";
import {makeStyles, withStyles} from "@material-ui/styles";
import {useAppDispatch, useAppSelector} from "app/hooks";
import BACKGROUND from "assets/img/bg_manager_lesson.png";
import LOADING from "assets/img/loading.gif";
import React from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {
  selectFilterLessonListHidden,
  selectLessonList,
  setFilterLessonListHidden,
} from "../../managerLessonSlice";
import EmptyComponent from "components/Empty";
export interface ListVideoHiddenProps {}

export default function ListVideoHidden(props: ListVideoHiddenProps) {
  const useStyles = makeStyles((theme: Theme) => ({
    background: {
      backgroundImage: `url(${BACKGROUND})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      height: 100,
      width: "100%",
      [theme.breakpoints?.up("xl")]: {
        width: "90%",
        height: 150,
      },
    },

    thumbnail_video: {
      width: 40,
      height: 40,
      objectFit: "cover",
    },

    percentHide: {
      width: "100%",
      position: "relative",
      backgroundColor: "#EFEFEF",
      height: 8,
      borderRadius: 8,
      marginTop: 5,
    },
    percent: {
      height: 8,
      borderRadius: 8,
      position: "absolute",
      top: 0,
      left: 0,
    },
    percentView: {
      backgroundColor: "#F1A34D",
    },
    percentLike: {
      backgroundColor: "  #0499C8",
    },

    btn_delete: {
      color: "#DC2626",
      backgroundColor: "#FEF2F2",
      borderRadius: 8,
      fontSize: 12,
      fontWeight: 700,
      padding: "6px 14px",
      marginRight: 4,
      border: "none",
      cursor: "pointer",
      textTransform: "none",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "#DC2626",
        color: "#FFFFFF",
        boxShadow: "0 4px 12px rgba(220, 38, 38, 0.25)",
      },
    },
    btn_detail: {
      color: "#0284C7",
      backgroundColor: "#F0F9FF",
      borderRadius: 8,
      fontSize: 12,
      fontWeight: 700,
      padding: "6px 14px",
      margin: "0 4px",
      border: "none",
      cursor: "pointer",
      textTransform: "none",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "#0284C7",
        color: "#FFFFFF",
        boxShadow: "0 4px 12px rgba(2, 132, 199, 0.25)",
      },
    },
    btn_add: {
      color: "#4F46E5",
      backgroundColor: "#EEF2FF",
      borderRadius: 8,
      fontSize: 12,
      fontWeight: 700,
      padding: "6px 14px",
      margin: "0 4px",
      border: "none",
      cursor: "pointer",
      textTransform: "none",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "#4F46E5",
        color: "#FFFFFF",
        boxShadow: "0 4px 12px rgba(79, 70, 229, 0.25)",
      },
    },
    btn_list_missing: {
      color: "#7C3AED",
      backgroundColor: "#F5F3FF",
      borderRadius: 8,
      fontSize: 12,
      fontWeight: 700,
      padding: "6px 14px",
      margin: "0 4px",
      border: "none",
      cursor: "pointer",
      textTransform: "none",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "#7C3AED",
        color: "#FFFFFF",
        boxShadow: "0 4px 12px rgba(124, 58, 237, 0.25)",
      },
    },
    root_modal: {
      width: "100%",
      height: "60%",
      display: "flex",
      justifyContent: "center",
    },
    modal__container: {
      width: "100%",
      maxWidth: 560,
      borderRadius: 12,
      backgroundColor: "#fff",
      zIndex: 9,
      display: "flex",
      flexDirection: "column",
      margin: "30px 0",
    },
    modal__header: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      padding: "0 24px",
      minHeight: 20,
      borderBottom: "1px solid rgb(235, 235, 235)",
      "& >h6": {
        fontWeight: 700,
        fontSize: 18,
        marginRight: 50,
      },
    },
    icon_play: {
      padding: 5,
      backgroundColor: "#fff",
      width: 50,
      height: 50,
      borderRadius: "50%",
      color: "#f9ab00",
      transition: "ease-in 0.5s",
      border: "8px solid #999",
      "&:hover": {
        backgroundColor: "#f9ab00",
        color: "#fff",
      },
    },
    container: {
      maxHeight: 500,
      [theme.breakpoints?.down("sm")]: {
        display: "none",
      },
    },
    mobileListView: {
      display: "none",
      [theme.breakpoints?.down("sm")]: {
        display: "block",
        padding: "20px 10px",
      },
    },
    mobileCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      border: "1px solid #E2E8F0",
      padding: 16,
      marginBottom: 12,
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.02)",
    },
    mobileCardHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 12,
    },
    mobileCardBody: {
      display: "flex",
      flexDirection: "column",
      gap: 8,
      marginBottom: 14,
      backgroundColor: "#F8FAFC",
      padding: "12px 14px",
      borderRadius: 10,
    },
    mobileCardRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    mobileCardActions: {
      display: "flex",
      gap: 8,
      justifyContent: "flex-end",
      flexWrap: "wrap",
    },
    paginationContainer: {
      marginTop: 24,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#FFFFFF",
      padding: "16px 24px",
      borderRadius: 16,
      border: "1px solid #E2E8F0",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
      [theme.breakpoints?.down("sm")]: {
        flexDirection: "column",
        gap: 12,
        padding: "16px 12px",
        borderRadius: 12,
      },
    },
  }));
  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "16px 5px",
        // backgroundColor: "#F3F3F3CC",
        color: "#1B1B1B",
        fontSize: 11,
        fontWeight: 700,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        borderBottom: "1px solid #777777",
        top: "0 !important",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
      body: {
        padding: "16px 5px",
        fontSize: 11,
        borderRight: "1px solid rgba(224, 224, 224, 0.8)",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
    })
  )(TableCell);

  const {t} = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const listLesson = useAppSelector(selectLessonList);
  const filter = useAppSelector(selectFilterLessonListHidden);
  const handleChangePage = (page: number) => {
    dispatch(
      setFilterLessonListHidden({
        ...filter,
        page: page - 1,
      })
    );
  };
  const handleClick = (id: number, name: string, decription: string, videoUrl: string) => {
    navigate(`/admin/manager-lesson/reup/${id}`, {
      state: {
        id: id,
        name: name,
        decription: decription,
        videoUrl: videoUrl,
        back: "/admin/manager-lesson",
      },
    });
  };

  return (
    <>
      {" "}
      {listLesson?.totalPages > 0 ? (
        <>
          <TableContainer component={Paper} className={classes.container}>
          <Table stickyHeader style={{minWidth: "800px"}}>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center" width="60px">
                  {t("managerLesson.video")}
                </StyledTableCell>
                <StyledTableCell align="left" width="260px">
                  {t("managerLesson.tenbaihoc")}
                </StyledTableCell>
                <StyledTableCell align="left" width="110px">
                  {t("managerLesson.ngaydang")}
                </StyledTableCell>
                <StyledTableCell align="left" width="120px">
                  Thời gian ẩn
                </StyledTableCell>
                <StyledTableCell align="center" width="180px">
                  {t("thaotac")}
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listLesson?.content.map((lesson) => (
                <TableRow key={lesson.id} hover>
                  <StyledTableCell align="center">
                    {lesson.attachment ? (
                      <img
                        src={lesson.attachment?.urlThumbnail}
                        alt="thumbnal_video"
                        className={classes.thumbnail_video}
                        style={{ borderRadius: 8 }}
                      />
                    ) : lesson.powerPointFileList?.[0]?.powerPointFile?.urlThumbnail ? (
                      <img
                        src={lesson.powerPointFileList?.[0]?.powerPointFile?.urlThumbnail}
                        alt="thumbnal_video"
                        className={classes.thumbnail_video}
                        style={{ borderRadius: 8 }}
                      />
                    ) : (
                      <img src={LOADING} alt="thumbnal_video" className={classes.thumbnail_video} style={{ borderRadius: 8 }} />
                    )}
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <Box style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <Typography style={{ fontWeight: 800, color: "#0F172A", fontSize: "0.875rem" }}>
                        {lesson.lessionName || "---"}
                      </Typography>
                      <Typography style={{ color: "#64748B", fontSize: "0.75rem", fontWeight: 500 }}>
                        Người đăng: {lesson?.user?.name || "---"}
                      </Typography>
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <Typography style={{ fontWeight: 600, color: "#334155", fontSize: "0.8125rem" }}>
                      {lesson?.publishDate ? `${String(lesson.publishDate).slice(-2)}/${String(lesson.publishDate).slice(4, 6)}/${String(lesson.publishDate).slice(0, 4)}` : "---"}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell align="left">
                    <Box style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                      <Typography style={{ fontWeight: 700, color: "#0F172A", fontSize: "0.8125rem" }}>
                        {lesson?.expiryDateTimeAsString ? String(lesson.expiryDateTimeAsString).slice(8) : "---"}
                      </Typography>
                      <Typography style={{ color: "#64748B", fontSize: "0.75rem", fontWeight: 500 }}>
                        {lesson?.expiryDateTimeAsString ? String(lesson.expiryDateTimeAsString).slice(0, 5) : ""}
                      </Typography>
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <Box display="flex" justifyContent="center" alignItems="center">
                      <Button
                        onClick={() =>
                          handleClick(
                            lesson?.id,
                            lesson?.lessionName,
                            lesson?.lessionDescription,
                            lesson?.attachment?.url
                          )
                        }
                        className={classes.btn_add}
                        size="small"
                      >
                        {t("managerLesson.taobaihoc")}
                      </Button>
                    </Box>
                  </StyledTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Mobile View: ListView */}
        {isMobile && (
          <Box className={classes.mobileListView}>
            {listLesson?.content.map((lesson) => (
              <Box key={lesson.id} className={classes.mobileCard}>
                {/* Card Header: Video Thumbnail & Lesson Name */}
                <Box className={classes.mobileCardHeader}>
                  <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                    {lesson.attachment ? (
                      <img
                        src={lesson.attachment?.urlThumbnail}
                        alt="thumbnail_video"
                        className={classes.thumbnail_video}
                        style={{ borderRadius: 8 }}
                      />
                    ) : lesson.powerPointFileList?.[0]?.powerPointFile?.urlThumbnail ? (
                      <img
                        src={lesson.powerPointFileList?.[0]?.powerPointFile?.urlThumbnail}
                        alt="thumbnail_video"
                        className={classes.thumbnail_video}
                        style={{ borderRadius: 8 }}
                      />
                    ) : (
                      <Box
                        style={{
                          width: 40,
                          height: 40,
                          backgroundColor: "#E2E8F0",
                          borderRadius: 8,
                        }}
                      />
                    )}
                    <Box>
                      <Typography variant="subtitle2" style={{ fontWeight: 800, color: "#0F172A" }}>
                        {lesson.lessionName}
                      </Typography>
                      <Typography variant="caption" style={{ color: "#64748B" }}>
                        Người đăng: {lesson?.user?.name || "---"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Card Body: Info rows */}
                <Box className={classes.mobileCardBody}>
                  <Box className={classes.mobileCardRow}>
                    <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                      NGÀY ĐĂNG
                    </Typography>
                    <Typography variant="caption" style={{ fontWeight: 600, color: "#334155" }}>
                      {lesson?.publishDate ? `${String(lesson.publishDate).slice(-2)}/${String(lesson.publishDate).slice(4, 6)}/${String(lesson.publishDate).slice(0, 4)}` : "---"}
                    </Typography>
                  </Box>

                  <Box className={classes.mobileCardRow}>
                    <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                      NGÀY ẨN
                    </Typography>
                    <Typography variant="caption" style={{ fontWeight: 600, color: "#334155" }}>
                      {lesson?.expiryDateTimeAsString ? String(lesson.expiryDateTimeAsString).slice(8) : "---"}
                    </Typography>
                  </Box>

                  <Box className={classes.mobileCardRow}>
                    <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                      GIỜ ẨN
                    </Typography>
                    <Typography variant="caption" style={{ fontWeight: 600, color: "#334155" }}>
                      {lesson?.expiryDateTimeAsString ? String(lesson.expiryDateTimeAsString).slice(0, 5) : "---"}
                    </Typography>
                  </Box>
                </Box>

                {/* Card Actions */}
                <Box className={classes.mobileCardActions}>
                  <Button
                    onClick={() =>
                      handleClick(
                        lesson?.id,
                        lesson?.lessionName,
                        lesson?.lessionDescription,
                        lesson?.attachment?.url
                      )
                    }
                    className={classes.btn_add}
                    size="small"
                    style={{ margin: 0 }}
                  >
                    Tạo bài học
                  </Button>
                </Box>
              </Box>
            ))}
          </Box>
        )}
        </>
      ) : (
        <Box p={2}>
          {" "}
          <EmptyComponent isBorder={false} />
        </Box>
      )}

      {listLesson?.totalPages > 1 && (
        <Box className={classes.paginationContainer}>
          <Typography variant="subtitle2" style={{fontWeight: 600}}>
            {t("managerLesson.tongbaihoc")}: {listLesson.totalElements}
          </Typography>
          <Pagination
            count={Math.ceil(listLesson?.totalElements / listLesson?.size)}
            page={listLesson?.number + 1}
            variant="outlined"
            color="primary"
            shape="rounded"
            size={isMobile ? "small" : "medium"}
            siblingCount={isMobile ? 0 : 1}
            onChange={(e, page) => handleChangePage(page)}
          />
        </Box>
      )}
    </>
  );
}
